
import { useState, useEffect } from 'react';

export const usePWAStandalone = () => {
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const checkStandalone = () => {
      // Check if app is running in standalone mode (installed PWA)
      const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;
      const isInWebAppMode = (window.navigator as any).standalone === true;
      const standalone = isInStandaloneMode || isInWebAppMode;
      
      console.log('PWA Standalone Check:', {
        isInStandaloneMode,
        isInWebAppMode,
        standalone
      });
      
      setIsStandalone(standalone);
    };

    checkStandalone();

    // Listen for display mode changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleChange = () => checkStandalone();
    
    mediaQuery.addEventListener('change', handleChange);
    
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return isStandalone;
};
